import React from 'react';
import { ActionsTab, NewContactsTable } from '../../_components';
import ContactsFiltersProvider, { useContactsFilters } from '../../_components/ContactsFilters/ContactsFiltersContext';
import ContactsFilters from '../../_components/ContactsFilters/ContactsFilters';
import { staticStyles } from './style';

const ContactsContent = () => {
  const { change, loading, filters } = useContactsFilters();
  return (
    <div className="ContactsPage">
      <ActionsTab />
      <ContactsFilters />
      {!loading && Object.keys(filters).length > 0 && (
        <NewContactsTable
          onTagSelect={value => {
            change('tagContactFilter', { operator: 'in', values: [String(value)] });
          }}
        />
      )}
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

const ContactsPage = () => (
  <ContactsFiltersProvider>
    <ContactsContent />
  </ContactsFiltersProvider>
);
export default ContactsPage;
